export const PRINTING_WELCOME = 0
export const WAITING_PLAYERS = 1
export const IN_GAME = 2
export const OUTRO_ANIMATION = 3
export const LEVEL_TRANSITION = 4
export const DISCONNECTED = 5
export const GAME_OVER = 6



// WEBPACK FOOTER //
// ./src/gameStatuses.js